const ANALYTICS_DEBUG = false;

export default class Analytics {

    static initializeEvents() {
        Array
            .from(document.querySelectorAll('[data-analytics-tag]'))
            .forEach(item => item.addEventListener('click', event => {
                let [name, key, value] = event.currentTarget.dataset.analyticsTag.split('||');

                if (value && value.includes('@auto')) {
                    value = value.replace(/@auto/, event.currentTarget.innerText.trim());
                }

                if (key && key.includes('@url')) {
                    key = key.replace(/@url/, window.location.pathname);
                }

                this.push(name, key, value);
            }));
    }

    static push(name, key, value) {
        const check = item => item !== undefined && item !== '';
        if (!check(name) || !check(key)) {
            console.warn('Analytics.push: invalid function call.', {name, key, value});

            return;
        }

        if (typeof EA_push !== 'function') {
            console.warn('Analytics.push: Eulerian API isn\'t yet avalaible.');

            return;
        }

        value = value === undefined ? '-' : String(value).trim();

        let options = [
            'actionname', name,
            'actionpname', key,
            'actionpvalue', value
        ];

        if (ANALYTICS_DEBUG) {
            console.info('Analytics.push: send event for "' + name + '".');
            console.table({name, key, value});
        }

        EA_push('action', options);
    }

    static attachTo(element) {
        if (!element || element.dataset.analyticsAttached) return;

        element.addEventListener('click', event => {
            let [name, key, value] = element.dataset.analyticsTag.split('||');
            Analytics.push(name, key, value);
        });

        element.dataset.analyticsAttached = 'true';
    }
}
